import * as types from '../actions/preferences/types';


const INITIAL_STATE = {};

export default function authenticatedPreferencesReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.AUTHENTICATED_PREFERENCES:
      // console.log('AUTH PREFS', action.payload);
      return action.payload;

    default: return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/authenticatedPreferencesReducer.js